import { render, staticRenderFns } from "./MelodyView.vue?vue&type=template&id=b14af324&scoped=true"
import script from "./MelodyView.vue?vue&type=script&lang=ts"
export * from "./MelodyView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14af324",
  null
  
)

export default component.exports